export default __webpack_public_path__ + "static/media/dotsorange1.56ca5b04.gif";